export default __webpack_public_path__ + "static/media/times.466a9823.svg";